import { store } from '@/store/store';

const redirect = (destination) => {
  const iFrameParentUrl = store.getters.iFrameParentUrl;
  if(iFrameParentUrl) {
    if(getUrlVars('from')) {
      destination = getUrlVars('from');
    }
  }

  if(parent !== window) {
    var des = decodeURIComponent(window.top.location.origin + destination);
    window.top.location.href = des;
  } else {
    window.location.href = decodeURIComponent(window.location.origin + destination);
  }
};

const getUrlVars = (param) => {
  const iFrameParentUrl = store.getters.iFrameParentUrl;
  if(iFrameParentUrl) {
    let vars = {};
    iFrameParentUrl.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m,key,value) {
        vars[key] = value;
    });
    return vars[param];
  }
};

const redirectToLogin = () => {
  redirect('/login');
};

const redirectToResetPassword = () => {
  redirect('/app/#/reset-password-request');
};

export {
  redirect,
  getUrlVars,
  redirectToLogin,
  redirectToResetPassword
};
